var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4560_2549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1474 6.31152H0.529297V9.73099H15.1474V6.31152Z",
    fill: "#4318FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8459 10.3679H3.22778V13.7874H17.8459V10.3679Z",
    fill: "#4318FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1474 14.4243H0.529297V17.8438H15.1474V14.4243Z",
    fill: "#4318FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77335 5.94953C5.41627 5.94953 6.74811 4.61768 6.74811 2.97477C6.74811 1.33185 5.41627 0 3.77335 0C2.13043 0 0.798584 1.33185 0.798584 2.97477C0.798584 4.61768 2.13043 5.94953 3.77335 5.94953Z",
    fill: "#4318FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4560_2549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.d7486b111a9c86f4c504425172ec5336.svg";
export { ForwardRef as ReactComponent };